import { LOCALES } from '@constants/constants';
import useStore from '@hooks/useStore';
import getInternalRoute from '@utils/getInternalRoute';
import Head from 'next/head';

export default function CanonicalUrl() {
  const {
    store: { page, locale },
  } = useStore();

  if (!page?.typename) return null;

  if (page.typename === 'HomePage') {
    return (
      <Head>
        <link
          rel="canonical"
          href={`${process.env.ENVIRONMENT_URL}${locale}`}
        />
        <link
          rel="alternate"
          hrefLang="x-default"
          href={`${process.env.ENVIRONMENT_URL}nl`}
        />
        <link
          rel="alternate"
          hrefLang="nl"
          href={`${process.env.ENVIRONMENT_URL}nl`}
        />
        <link
          rel="alternate"
          hrefLang="en"
          href={`${process.env.ENVIRONMENT_URL}en`}
        />
      </Head>
    );
  }

  const canonicalUrl = `${
    process.env.ENVIRONMENT_URL
  }${locale}/${getInternalRoute({
    internalLink: page,
    locale,
  })}`;

  const nlLocalization = page.localizations?.find(
    localization => localization.locale === LOCALES.nl,
  );
  const enLocalization = page.localizations?.find(
    localization => localization.locale === LOCALES.en,
  );

  return (
    <Head>
      {/* canonical */}
      <link rel="canonical" href={canonicalUrl} />

      {/* hreflang - only render for available locales */}
      {!!nlLocalization && (
        <>
          <link
            rel="alternate"
            hrefLang="x-default"
            href={`${process.env.ENVIRONMENT_URL}nl/${getInternalRoute({
              internalLink: { ...page, slug: nlLocalization.slug },
              locale: 'nl',
            })}`}
          />
          <link
            rel="alternate"
            hrefLang="nl"
            href={`${process.env.ENVIRONMENT_URL}nl/${getInternalRoute({
              internalLink: { ...page, slug: nlLocalization.slug },
              locale: 'nl',
            })}`}
          />
        </>
      )}
      {!!enLocalization && (
        <link
          rel="alternate"
          hrefLang="en"
          href={`${process.env.ENVIRONMENT_URL}en/${getInternalRoute({
            internalLink: { ...page, slug: enLocalization.slug },
            locale: 'en',
          })}`}
        />
      )}
    </Head>
  );
}
